import { render, staticRenderFns } from "./RoleUser.vue?vue&type=template&id=7d9d01e0&scoped=true"
import script from "./RoleUser.vue?vue&type=script&lang=ts"
export * from "./RoleUser.vue?vue&type=script&lang=ts"
import style1 from "./RoleUser.vue?vue&type=style&index=1&id=7d9d01e0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9d01e0",
  null
  
)

export default component.exports